import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import Button from "../../../../components/forms/Button";
import { FaMagic } from "@react-icons/all-files/fa/FaMagic";
import { setModalState } from "../../../../store/reducers/Modal/actions";
import { IoMdStats } from '@react-icons/all-files/io/IoMdStats'
import { isMobile } from "../../../../services/clientService";
import { push } from "connected-react-router";
import { getTaskStatus } from "../../../../services/savedJobService";
import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";

const Stats = props => {
    const { numOfSavedJobs, numOfTasks, numOfInterviews, numOfAppliedJobs } = useSelector(({ JobsReducer }) => JobsReducer);
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer)
    const dispatch = useDispatch()
    console.log(props)
    
    return (
        <div className="stats">

            <div className="stat-item">
                <div className="left">
                    <div className="text">
                        <IoMdStats />
                        Resume Files</div>
                    <div className="value">{userDetails?.resumeFiles?.length || 0}</div>
                </div>
            </div>
            <div className="stat-item">
                <div className="left">
                    <div className="text">
                        <IoMdStats />
                        Saved Jobs</div>
                    <div className="value">{numOfSavedJobs || 0}</div>
                </div>
                <div className="right">
                    {/* {props.variant !== 'savedJobs' && <Button className="upgrade-btn" onClick={() => dispatch(push('/saved-jobs'))}>Optimize
                        {!isMobile() && <FaMagic />}
                    </Button>} */}
                </div>                
            </div>
            <div className="stat-item">
                <div className="left">
                    <div className="text">
                        <IoMdStats />
                        Applied</div>
                    <div className="value">{numOfAppliedJobs || 0}</div>
                </div>
            </div>
            <div className="stat-item">
                <div className="left">
                    <div className="text">
                        <IoMdStats />
                        Subscription</div>
                    <div className="value" style={{display: 'flex', alignItems: 'center'}}><div>Active</div> <div style={{display: 'flex', alignItems: 'center', marginLeft: 10, marginTop: 5}}><FaCheckCircle style={{fontSize: 22, color: '#00cb6f'}} /></div></div>
                </div>
            </div>
        </div>
    )
}

export default Stats;